@if (trackingsResumeModel) {
  <mat-form-field class="user-select m-3">
    <mat-label>Utilisateurs</mat-label>
    <mat-select (selectionChange)="onSelectionChange($event)">
      @for (trackingResume of trackingsResumeModel; track trackingResume) {
        <mat-option [value]="trackingResume.ssoId">
          {{trackingResume.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (courseResume.length > 0) {
  <div class="course-table mat-elevation-z8 m-3">
    <table mat-table [dataSource]="dataSource" class="mat-table-novo">
      <!-- Course Name Column -->
      <ng-container matColumnDef="courseName">
        <th mat-header-cell *matHeaderCellDef style="color: red; font-size: 15px;"> Cours </th>
        <td mat-cell *matCellDef="let element"> {{element.courseName}} </td>
      </ng-container>
      <!-- Is Completed Column -->
      <ng-container matColumnDef="isCompleted">
        <th mat-header-cell *matHeaderCellDef style="color: red; font-size: 15px;"> Est complété ? </th>
        <td mat-cell *matCellDef="let element">
          <span class="completed-status" [class.completed]="element.isCompleted">
            {{element.isCompleted ? 'Oui' : 'Non'}}
          </span>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
}
